module.exports = __webpack_public_path__ + "static/media/airbnbalert.4c7e36ba.svg";